import { render, staticRenderFns } from "./TabsNews.vue?vue&type=template&id=1bf2205e&scoped=true&"
import script from "./TabsNews.vue?vue&type=script&lang=js&"
export * from "./TabsNews.vue?vue&type=script&lang=js&"
import style0 from "./TabsNews.vue?vue&type=style&index=0&id=1bf2205e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2205e",
  null
  
)

export default component.exports